import axios from "axios";

const rawApiBaseUrl =
  process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || "";

const client = axios.create({
  baseURL: rawApiBaseUrl.replace(/\/api\/?$/, ""),
  timeout: Number(process.env.REACT_APP_API_TIMEOUT) || 120000,
  withCredentials: true,
  withXSRFToken: true,
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "X-CSRFToken",
});

export const request = (config) => client(config).then(({ data }) => data);
